import { useEffect, useState, useCallback } from 'react';
import debounce from 'lodash.debounce';
export const useShowScrollButtons = (ref) => {
    const [isScrollable, setIsScrollable] = useState(false);
    const [inactiveArrow, setInactiveArrow] = useState(undefined);
    const checkScrollable = useCallback(debounce(() => {
        if (!ref.current)
            return;
        const { scrollWidth, clientWidth } = ref.current;
        setIsScrollable(scrollWidth > clientWidth);
    }, 50), [ref]);
    const getInactiveArrow = useCallback(debounce(() => {
        if (!ref.current)
            return;
        const { scrollLeft, clientWidth, scrollWidth } = ref.current;
        if (scrollLeft === 0) {
            return setInactiveArrow('left');
        }
        if (clientWidth + scrollLeft === scrollWidth) {
            return setInactiveArrow('right');
        }
        return setInactiveArrow(undefined);
    }, 100), [ref]);
    useEffect(() => {
        checkScrollable();
        getInactiveArrow();
        window.addEventListener('resize', checkScrollable);
        ref.current?.addEventListener('scroll', getInactiveArrow);
        return () => {
            window.removeEventListener('resize', checkScrollable);
            ref.current?.removeEventListener('scroll', getInactiveArrow);
        };
    }, [ref]);
    return { isScrollable, inactiveArrow };
};
//# sourceMappingURL=use-show-scroll-buttons.js.map